export default {
    auth: {
        attendance_success: "📅 Anwesenheitsprüfung abgeschlossen! (Daily Rewards)\nHeute +50 Punkte Bonus erhalten!",
        signup_bonus: "Registrierung erfolgreich! 🎉\nWillkommensbonus +100 Punkte erhalten!",
        referral_bonus: "Einladungsregistrierung abgeschlossen! 🤝\nWillkommensbonus 100P + Empfehlungsbonus 500P\nInsgesamt 600 Punkte erhalten!",
        login_required: "Anmeldung erforderlich"
    },
    social: {
        subscribe_on: "Zur Aboliste hinzugefügt.",
        subscribe_off: "Abo abbestellt.",
        like_on: "Gefällt mir!",
        like_off: "Gefällt mir entfernt.",
        follow_on: "Gefolgt.",
        follow_off: "Entfolgt."
    },
    comment: {
        submit_success: "Kommentar gepostet.",
        delete_confirm: "Sind Sie sicher, dass Sie löschen möchten?",
        delete_success: "Gelöscht.",
        delete_error: "Löschfehler",
        submit_error: "Fehler beim Posten des Kommentars",
        empty_error: "Bitte geben Sie Inhalt ein."
    },
    payment: {
        verify_success: "Überprüfung abgeschlossen!\n{amount} Sterne aufgeladen.",
        verify_fail: "Überprüfungsfehler",
        user_cancel: "Zahlung abgebrochen.",
        error: "Zahlungsfehler"
    },
    common: {
        confirm: "Bestätigen",
        cancel: "Abbrechen",
        close: "Schließen",
        save: "Speichern",
        delete: "Löschen",
        edit: "Bearbeiten",
        copy: "Kopieren",
        loading: "Lädt...",
        error: "Ein Fehler ist aufgetreten.",
        success: "Erfolg.",
        webtoon: "Webtoon",
        webnovel: "Webroman",
        cinenovel: "Cine-Novel",
        published: "Veröffentlicht",
        draft: "Entwurf",
        editor: "Editor"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "Nutzungsbedingungen",
        privacy: "Datenschutzrichtlinie",
        report: "Beschwerdezentrum",
        biz_ceo: "CEO",
        biz_addr: "Adresse",
        biz_tel: "Support",
        biz_email: "E-Mail",
        biz_license: "Lizenz",
        biz_mail_order: "E-Commerce",
        biz_none: "Keine Info",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "Startseite",
        webtoon: "Webtoon",
        webnovel: "Webroman",
        novel: "Webroman",
        davinci: "Da Vinci",
        studio: "Autorenstudio",
        library: "Bibliothek",
        support: "Support",
        admin: "Admin",
        config: "Externe Links",
        factory: "Popups & Benachrichtigungen",
        docs: "Dokumenteneditor",
        analytics: "Trendanalyse",
        plaza: "Ssulwha Club",
        wisdom: "Weisheit der Sterne",
        recommendation: "Leeres Regal",
        charge: "Sternenstation",
        guide: "Leitfaden",
        "whats-new": "Neuigkeiten",
        invite: "Freunde einladen",
        about: "Über den Dienst",
        terms: "Nutzungsbedingungen",
        privacy: "Datenschutzrichtlinie",
        report: "Beschwerdezentrum",
        "app-setting": "App-Einstellungen",
        login: "Anmelden / Registrieren",
        logout: "Abmelden",
        MyPage: "Meine Seite",
        notice: "Benachrichtigungen",
        proposal: "Vorschlag",
        settings: "Einstellungen",
        language: "Sprache"
    },
    modal: {
        translate_title: "Sprachauswahl",
        translate_placeholder: "Bitte wählen Sie eine Sprache zum Übersetzen.",
        translate_start: "Übersetzen"
    },
    msg: {
        welcome_beta: "Willkommen zur Mirinae Beta.",
        login_required: "Melden Sie sich an, um mehr Geschichten freizuschalten.",
        login_btn: "Anmelden / Registrieren"
    },
    profile: {
        follow: "Folgen",
        following: "Folge ich",
        mypage: "Meine Seite",
        followers: "Follower",
        following_count: "Folge ich",
        bio_empty: "Keine Vorstellung.",
        works: "Werke",
        feed: "Feed",
        guestbook: "Gästebuch",
        works_empty: "Keine Werke registriert.",
        works_error: "Fehler beim Laden der Werke",
        feed_empty: "Keine Beiträge.",
        feed_error: "Fehler beim Laden des Feeds.",
        feed_error_detail: "Indexierung läuft oder Netzwerkfehler.",
        follow_error: "Fehler beim Folgen."
    },
    support: {
        title: "1:1 Support-Center",
        input_placeholder: "Geben Sie Ihre Anfrage ein...",
        empty_state_title: "Kein Beratungsverlauf.",
        empty_state_desc: "Fragen Sie uns jederzeit alles!",
        status_received: " • Empfangen",
        auto_reply: "Ihre Anfrage ist eingegangen. Wir werden nacheinander antworten. Genießen Sie in der Zwischenzeit Ssulwha World.",
        send_fail: "Nachricht konnte nicht gesendet werden"
    },
    author: {
        apply_title: "Autorenbewerbung",
        apply_desc: "Teilen Sie Ihre Geschichte mit der Welt. Hinterlassen Sie eine kurze Vorstellung und ein Portfolio, wir melden uns nach der Prüfung.",
        email_label: "E-Mail",
        email_placeholder: "Kontakt-E-Mail eingeben",
        email_hint: "Wir kontaktieren Sie möglicherweise bezüglich Genehmigungsergebnissen und Verträgen.",
        intro_label: "Vorstellung",
        intro_placeholder: "Bitte stellen Sie sich vor (Schreiberfahrung, Stil usw.)",
        portfolio_label: "Portfolio (Optional)",
        submit_btn: "Bewerben",
        email_required: "Bitte geben Sie Ihre E-Mail ein.",
        intro_required: "Bitte geben Sie Ihre Vorstellung ein.",
        submitting: "Wird gesendet...",
        submit_success: "Autorenbewerbung gesendet."
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    library: {
        empty_title: "Bibliothek ist leer",
        empty_desc: "Gekaufte oder angesehene Werke werden hier erscheinen.",
        explore_btn: "Werke durchsuchen",
        select_hint: "Wählen Sie ein Werk aus, um die Liste anzuzeigen.",
        total_episodes: "Gesamt {n} Episoden"
    },
    badge: {
        best_reviewer: "Top-Rezensent",
        top_author: "Top-Autor",
        vip: "VIP",
        donation_king: "Spendenkönig",
        hall_of_fame: "Ruhmeshalle"
    },
    tab: {
        works: "Werke",
        feed: "Ssulwha (Feed)",
        guestbook: "Gästebuch"
    },
    tag: {
        fantasy: "Fantasy",
        romance: "Romantik",
        martial_arts: "Kampfkunst",
        drama: "Drama",
        slice_of_life: "Alltagsleben",
        comedy: "Komödie",
        thriller: "Thriller",
        school: "Schule",
        munchkin: "Munchkin",
        regression: "Rückkehr",
        possession: "Besessenheit",
        system: "System",
        growth: "Wachstum",
        revenge: "Rache",
        heart: "Herz",
        horror: "Horror",
        sport: "Sport",
        history: "Alt. Geschichte"
    },
    guestbook: {
        title: "Gästebuch",
        input_placeholder: "Hinterlassen Sie eine unterstützende Nachricht!",
        secret: "Geheim",
        submit: "Senden",
        empty: "Hinterlassen Sie die erste Nachricht! 👣",
        secret_content: "Dies ist eine geheime Nachricht.",
        delete_confirm: "Sind Sie sicher?",
        reply: "Antworten",
        reply_placeholder: "Antwort schreiben...",
        reply_delete_confirm: "Antwort löschen?",
        confirm_delete_reply: "Diese Antwort löschen?",
        submit_error: "Senden fehlgeschlagen: ",
        emoji_error: "Emoji laden fehlgeschlagen"
    },
    pwa: {
        install_title: "Installieren",
        install_desc: "Erleben Sie es schneller und besser.",
        install_btn: "Installieren",
        later_btn: "Später",
        ios_guide_title: "Auf dem iPhone installieren",
        ios_guide_desc: "Genießen Sie das beste Erlebnis im Vollbildmodus.",
        ios_step1: "Tippen Sie auf 'Teilen'",
        ios_step2: "Wählen Sie 'Zum Home-Bildschirm'",
        update_title: "Neue Version ({version})!",
        update_title_v2: "Eine neue Version ist verfügbar!",
        update_desc: "Aktualisieren Sie für neue Funktionen.",
        update_btn: "Aktualisieren",
        updating: "Aktualisierung...",
        offline_title: "Sie sind offline",
        offline_desc: "Bitte überprüfen Sie das Internet.",
        copy_success: "Kopiert",
        copy_fail: "Kopierfehler"
    },
    settings: {
        title: "App-Einstellungen",
        general: "Allgemein",
        push_title: "Push-Benachrichtigungen",
        push_desc: "Update-Benachrichtigungen erhalten",
        app_info: "App-Info",
        current_version: "Aktuelle Version",
        danger_zone: "Gefahrenzone",
        delete_account_title: "Konto löschen (Zurück zur Realität)",
        delete_account_desc: "Alle Daten werden gelöscht und können nicht wiederhergestellt werden.",
        delete_account_button: "Zurück zur Realität"
    },
    proposal: {
        title: "Weisheit der Sterne",
        desc: "Ihre strahlende Weisheit erweitert das Universum.",
        label_title: "Vorschlagstitel",
        placeholder_title: "Geben Sie den Kern Ihrer Idee ein",
        label_content: "Details",
        placeholder_content: "Teilen Sie Ihre Ideen frei. Je konkreter, desto besser!",
        btn_submit: "Weisheit senden",
        success_title: "Weisheit empfangen",
        success_desc: "{name}s Weisheit wurde aufgezeichnet.<br>Danke für Ihr wertvolles Feedback."
    },
    report: {
        title: "Beschwerdezentrum",
        category_label: "KATEGORIE",
        content_label: "INHALT",
        url_label: "VERWANDTE URL",
        categories: {
            general: "Allgemeine Anfrage / Sonstiges",
            spam: "Spam / Unangemessene Werbung",
            abuse: "Beleidigung / Hassrede",
            adult: "Inhalte für Erwachsene / Jugendschädlich",
            bug: "Systemfehler / Bug"
        },
        placeholder_content: "Bitte beschreiben Sie das Problem detailliert.",
        btn_submit: "Beschwerde einreichen",
        warning: "Falsche Beschwerden können zu Diensteinschränkungen führen.",
        success_title: "Beschwerde gesendet",
        success_desc: "Wir werden dies schnell prüfen und Maßnahmen ergreifen.<br>Danke für Ihre Meldung.",
        login_required: "Sie müssen angemeldet sein, um zu melden.",
        submit_success: "Beschwerde erfolgreich eingereicht.\nBitte überprüfen Sie im Admin-Center...",
        error: "Fehler beim Senden der Beschwerde",
        modal: {
            title: "Report",
            desc: "Please select a reason. False reports may result in service restrictions.",
            category: "Category",
            detail: "Detail",
            url: "Related URL",
            submit: "Submit",
            cancel: "Cancel"
        },
        reason: {
            spam: "Spam / Promotion",
            abusive: "Abusive Language",
            inappropriate: "Inappropriate Content",
            other: "Other / Inquiry"
        }
    },
    guide: {
        title: "Systemeinstellungen",
        desc: "Wir justieren den Kompass,<br>um Ihre Reise zu unterstützen.",
        wait: "Bitte warten Sie einen Moment."
    },
    viewer: {
        settings_title: "Audio/Scroll-Einstellungen",
        bgm_volume: "BGM-Lautstärke",
        bgm_off: "BGM Aus",
        auto_speed: "Auto-Geschwindigkeit",
        settings_btn: "Einstellungen",
        translate_btn: "KI-Übersetzung",
        tts_btn: "TTS-Lesen",
        bgm_btn: "BGM",
        top_btn: "Nach oben",
        auto_play: "Auto-Slide",
        auto_scroll: "Auto-Scroll",
        start_auto: "Auto-Play",
        stop_auto: "Gestoppt",
        tts_warn: "Hinweis: TTS liest in der Originalsprache (Koreanisch)."
    },
    login: {
        subtitle: "Wo Ihre Fantasie Realität wird",
        btn_google: "Weiter mit Google",
        or: "ODER",
        label_email: "E-Mail",
        label_password: "Passwort",
        btn_email_login: "Mit E-Mail anmelden",
        btn_email_signup: "Mit E-Mail registrieren",
        msg_no_account: "Kein Konto?",
        msg_has_account: "Bereits ein Konto?",
        btn_signup: "Registrieren",
        btn_login: "Anmelden",
        msg_processing: "Verarbeitung...",
        msg_email_sent: "Bestätigungs-E-Mail gesendet. Bitte prüfen und anmelden.",
        err_invalid_auth: "Ungültige E-Mail oder Passwort.",
        err_email_in_use: "E-Mail wird bereits verwendet.",
        err_default: "Ein Fehler ist aufgetreten."
    },
    terms: {
        title: "Einreisekontrolle",
        desc: "Willkommen in der SSULWHA-Welt.<br>Bitte stimmen Sie den Nutzungsbedingungen zu.",
        required: "[Erforderlich]",
        optional: "[Optional]",
        label_terms: "Nutzungsbedingungen",
        label_privacy: "Datenschutzrichtlinie",
        label_marketing: "Marketing-Zustimmung",
        btn_start: "Starten",
        btn_processing: "Verarbeitung..."
    },
    main: {
        banner_welcome: "✨ Entdecken Sie heute die SSULWHA-Welt!",
        search_placeholder: "Suche nach Werken, Autoren, Tags...",
        hall_of_fame: "Ruhmeshalle (Weekly Best)",
        hall_of_fame_locked: "Ruhmeshalle nur für Mitglieder sichtbar",
        hall_of_fame_desc: "Wer ist diese Woche der aktivste Benutzer? Melden Sie sich an, um das Ranking zu sehen!",
        login_btn: "Anmelden",
        todays_pick: "Auswahl des Tages",
        continue_reading: "Weiterlesen",
        trending: "Im Trend",
        new_arrivals: "Neuankömmlinge",
        all_works: "Alle Werke",
        tag_cloud: "Nach Tags",
        filter_all: "Alle",
        filter_webtoon: "Webtoon",
        filter_webnovel: "Webroman",
        realtime_club: "Echtzeit Ssulwha Club",
        enter_club: "Eintreten",
        be_the_first: "Starten Sie den ersten Stern!",
        go_to_plaza: "Zum Platz",
        search_results: "Suchergebnisse: '{query}'",
        search_no_results: "Keine Ergebnisse gefunden.",
        search_try_other: "Versuchen Sie andere Schlüsselwörter.",
        splash_loading: "Betrete Ssulwha-Welt...",
    },
    mypage: {
        tab_library: "Bibliothek",
        tab_history: "Verlauf",
        tab_activity: "Aktivität",
        tab_likes: "Favoriten",
        tab_wallet: "Brieftasche",
        tab_settings: "Einstellungen",
        no_activity: "Keine Aktivität.",
        go_to_plaza: "Zum Platz",
        followers: "Follower",
        following: "Folge ich",
        edit_profile_tooltip: "Profil bearbeiten",
        role_author: "Autor",
        role_reader: "Leser",
        role_admin: "Admin",
        author_pending: "⏳ Warten auf Genehmigung",
        btn_studio: "Autorenstudio",
        btn_apply_author: "Autor werden",
        default_bio: "Geben Sie eine kurze Vorstellung ein.",
        menu_edit_profile: "Profil bearbeiten",
        menu_public_profile: "Öffentliches Profil",
        current_version: "Aktuelle Version",
        invite_title: "Freunde einladen",
        invite_reward: "Belohnung +500P",
        invite_desc: "Teilen Sie den Link. Sie und Ihr Freund erhalten beide 500P!",
        invited_count: "Eingeladene Freunde",
        unit_people: "Pers.",
        edit_profile_title: "Profil bearbeiten",
        label_photo: "Profilfoto",
        btn_upload: "Hochladen",
        btn_random: "Zufällig",
        placeholder_photo_url: "Oder Bild-URL",
        label_nickname: "Spitzname",
        label_bio: "Bio",
        placeholder_bio: "Kurze Vorstellung über sich selbst"
    },

    plaza: {
        title: "Ssulwha Club",
        subtitle: "Emotionaler Kommunikationsraum für Gen Z",
        btn_sync: "⚡ Kommentare synch. (Admin Only)",
        composer_placeholder_init: "Welche Geschichte möchten Sie in dieses Universum starten?",
        composer_placeholder_thread: "Schreiben Sie die Geschichte weiter...",
        composer_placeholder_quote: "Hinterlassen Sie Gedanken zu dieser Geschichte...",
        btn_add_thread: "Thread hinzufügen",
        btn_submit: "Stern starten",
        btn_submit_quote: "Zitieren",
        btn_submitting: "Lädt...",
        quote_suffix: " zitiert"
    },
    recommendation: {
        loading_title: "Lese Ihre Flugbahn...",
        loading_desc: "Verbinde vergangene Schritte und Sterne, bei denen Sie verweilt haben",
        fallback_title: "Das Sternbild von <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>ist noch schwach.",
        fallback_desc: "Aber keine Sorge. <br>Wir haben strahlende Geschichten ausgewählt, die die Nächte vieler anderer erhellt haben.<br><span class=\"text-sm opacity-70 mt-1 block\">Wenn Ihre Fußabdrücke zunehmen, werden wir eine Umlaufbahn nur für Sie finden.</span>",
        personal_title: "Bücherregal von <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>,<br>Geschichte für den nächsten Slot",
        personal_desc: "Wir haben 5 Sterne gefunden, die mit Ihrem Geschmack resonieren.",
        label_empty_shelf: "Leeres Regal (The Empty Shelf)",
        btn_refresh: "Andere Empfehlungen",
        error_title: "Verbindung instabil",
        btn_retry: "Wiederholen",
        empty_data_title: "Unzureichende Daten",
        btn_browse: "Werke durchsuchen",
        widget_title: "Suchen Sie das<br>nächste Buch?",
        widget_desc: "Wir haben 5 Werke basierend auf {name}s Geschmack ausgewählt.",
        widget_desc_guest: "Wir haben 5 Werke basierend auf Ihrem Geschmack ausgewählt.",
        btn_check: "Jetzt ansehen"
    },
    star_station: {
        title: "Sternenstation",
        subtitle: "Genießen Sie Werke freier.",
        my_stars: "Meine Sterne",
        history_tab: "Verlauf",
        products_tab: "Produkte",
        payment_method: "Zahlungsmethode",
        btn_charge: "Aufladen",
        history_empty: "Kein Aufladeverlauf.",
        product_names: {
            stardust: "Sternenstaub",
            shooting_star: "Sternschnuppe",
            little_bear: "Kleiner Bär",
            silver_river: "Silberfluss",
            galaxy_master: "Galaxienmeister",
            star_maker: "Sternenschöpfer"
        }
    },
    studio: {
        title: "Kreativstudio",
        desc: "Raum für Ihre unendliche Fantasie.",
        dashboard: "Dashboard",
        series: "Serienverwaltung",
        statistics: "Statistik",
        profit: "Einnahmen",
        guide: "Autorenratgeber",
        new_series: "Neue Serie",
        edit_series: "Serie bearbeiten",
        new_episode: "Neue Episode",
        edit_episode: "Episode bearbeiten",
        open_menu: "Menü öffnen",
        exit: "Verlassen",
        lab_badge: "LAB",
        lab_title: "Da Vinci Labor",
        lab_desc: "Öffnen Sie eine neue Welt der Kreation mit KI.",
        total_views: "Aufrufe",
        total_likes: "Likes",
        total_followers: "Follower",
        weekly_performance: "Wöchentliche Leistung",
        views_trend_7d: "Aufruftrend (7 Tage)",
        live_data: "LIVE",
        my_series_list: "Meine Werke",
        total_series_count: "Gesamt {n} Werke",
        empty_series_title: "Starten Sie eine neue Geschichte",
        empty_series_desc: "Entfalten Sie Ihre Fantasie in die Welt.",
        btn_editor: "Editor",
        btn_settings: "Einstellungen",
        btn_delete: "Löschen",
        delete_modal_title: "Serie löschen",
        create_first_episode: "Erstelle deine erste Episode!",
        create_first_episode_desc: "Klicke auf den Button Neue Episode, um zu beginnen.",
        last_updated: "Zuletzt aktualisiert: {date}",
        delete_episode_title: "Episode löschen",
        delete_episode_content: "Möchten Sie die Episode '{title}' wirklich löschen?",

        // Toolbar
        bold: "Fett",
        italic: "Kursiv",
        highlight_red: "Hervorheben (Rot)",
        highlight_blue: "Hervorheben (Blau)",
        save_preserve_status: "Speichern (Status beibehalten)",
        delete_modal_content: "Möchten Sie '{title}' wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
    },
    editor: {
        davinci_editor: "DaVinci Editor",
        webnovel_editor: "Webroman Editor",
        webtoon_editor: "Webtoon Editor",
        episode_title: "Episodentitel",
        placeholder_title: "Episodentitel eingeben",
        content: "Inhalt",
        placeholder_content: "Schreiben Sie Ihre Geschichte hier...",
        author_note: "Autorennotiz",
        placeholder_note: "Ein Wort an Ihre Leser...",
        upload_image: "Bild hochladen",
        upload_cover: "Cover hochladen",
        save_draft: "Entwurf speichern",
        publish: "Veröffentlichen",
        ai_analysis: "KI-Analyse",
        ai_recommend: "KI-Empfehlung",
        tags: "Tags",
        placeholder_tags: "Tags hinzufügen (kommagetrennt)",
        preview: "Vorschau",
        settings: "Einstellungen",
        episode_prefix: "Episode",
        draft_mode_title: "Entwurfsmodus",
        draft_mode_private_desc: "Diese Episode ist derzeit versteckt.",
        display_mode: "Anzeigemodus",
        mode_webtoon: "Webtoon (Scroll)",
        mode_comic: "Comic (Seite)",
        mode_insta: "InstaToon",
        mode_desc: "Optimiert das Seherlebnis.",
        thumbnail: "Vorschaubild",
        bgm: "BGM",
        manuscript_images: "Manuskript",
        drag_drop_hint: "Bilder ziehen und ablegen oder Tippen zum Hochladen",
        set_draft: "In Entwurf",
        save_changes: "Änderungen speichern",
        live_preview: "Live-Vorschau",
        preview_hint: "Prüfen Sie, wie es auf Mobilgeräten aussieht.",
        val_webtoon_error: "[Webtoon-Modus Fehler] Bild zu breit (Verhältnis: {ratio}).<br>Webtoon-Modus erfordert vertikales Scrollen (Höhe > Breite * 1.2).<br>Für Einzelseiten verwenden Sie bitte den 'Comic'-Modus.",
        val_comic_error: "[Comic-Modus Fehler] Ungültiges Seitenverhältnis ({ratio}).<br>Erlaubte Formate:<br>- Vertikale Seite (ca. 2:3 bis 3:4)<br>- Horizontale Doppelseite (Breite > Höhe)<br><br>Lange Scrollstreifen sollten den 'Webtoon'-Modus verwenden.",
        val_insta_error: "[InstaToon Fehler] Ungültiges Seitenverhältnis ({ratio}).<br>Optimierung für Instagram erfordert Quadrat (1:1) oder Porträt (4:5).<br>Aktuelles Bild ist zu breit oder zu hoch.",
        approval_requested: "Genehmigung angefordert",
        approval_desc: "Ihre Arbeit wurde zur Genehmigung eingereicht.\\nSie wird nach Überprüfung durch den Administrator veröffentlicht.",
        pending_approval: "Warten auf Genehmigung",
        saved_to_draft: "In Entwurf gespeichert",
        published_start_ai: "Episode veröffentlicht! Starte KI-Analyse...",
        ai_trigger_fail: "Start der KI-Analyse fehlgeschlagen. Bitte verwenden Sie die 'KI-Analyse'-Schaltfläche manuell.",
        save_failed: "Speichern fehlgeschlagen: {e}",
        upload_complete: "Upload abgeschlossen",
        upload_fail_desc: "Bildupload fehlgeschlagen. (URL-Generierung fehlgeschlagen)\nBitte überprüfen Sie die Konsolenprotokolle.",
        image_mode_mismatch: "Das ausgewählte Bild entspricht nicht den Spezifikationen des {mode}-Modus.",
        invalid_format: "Ungültiges Format",
        mode_change_blocked: "Moduswechsel blockiert",
        mode_change_blocked_desc: "Einige vorhandene Bilder entsprechen nicht den {mode}-Spezifikationen. Bitte löschen Sie diese und versuchen Sie es erneut.",
        processing: "Verarbeitung...",
        tap_nav_hint: "Tippen Sie auf die Ränder zum Navigieren oder Scrollen",
        ai_analyze_title: "KI-Analyse bestätigen",
        ai_analyze_confirm: "KI-Analyse (OCR) auf diesen Bildern ausführen?\\nVorhandene Analysedaten werden aktualisiert.",
        save_required: "Bitte speichern Sie zuerst die Episode.",
        ai_requesting: "Anfrage an KI-Server... (OCR/SEO)",
        ai_processing_title: "KI-Verarbeitung",
        ai_no_items: "Keine Elemente analysiert (0).\\n\\n[Details]\\n{log}",
        diagnosis_report: "Diagnosebericht",
        ocr_complete: "OCR Abgeschlossen: {n} Frames",
        seo_trigger: "Auto-SEO-Generierung ausgelöst.",
        ai_complete_desc: "Analyse Abgeschlossen.\\n- OCR-Daten erstellt\\n- SEO-Metadaten ausstehend\\n(Werden in Kürze angezeigt)",
        ai_error: "KI-Verarbeitungsfehler",
        ai_fail_msg: "KI-Analyse Fehlgeschlagen: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        save: "Speichern",
        saved: "Gespeichert",
        saving: "Speichert...",
        complete: "Fertig",
        error: "Fehler",
        ai_analyze_btn: "KI-Analyse",
        ai_analyzing: "Analysiert...",
        series_info: "Serieninfo (Upload)",
        series_title: "Serientitel",
        cover_url: "Cover-URL",
        admin_readonly: "Nur Admin (Read Only)",
        chapters: "Kapitelliste",
        add_chapter: "Kapitel hinzufügen",
        delete_chapter_confirm: "Dieses Kapitel löschen?",
        untitled_episode: "Ohne Titel",
        bgm_label: "BGM (optional)",
        content_body: "Inhalt",
        load_txt: "TXT laden",
        text_too_short: "Text zu kurz.",
        upload_cover_fail: "Fehler beim Cover-Upload",
        create_series: "Serie erstellen",
        edit_series: "Serie bearbeiten",
        basic_info: "Basisinfo",
        episode_mgmt: "Episodenverwaltung",
        compliance: "Compliance",
        age_rating: "Altersfreigabe",
        age_guide: "Leitfaden",
        is_ai: "KI-Inhalte verwendet",
        desc_placeholder: "Handlungsbeschreibung eingeben...",
        cover_image: "Cover Image",

        series_status: "Series Status",
        admin_info: "Admin Info",
        format: "Format",

        publish_now: "Publish",
        format_locked: "Gesperrt",
        webtoon: "Webtoon (Webtoon)",
        webnovel: "Webroman (Webnovel)",
        cinenovel: "Cine-Novel",
        admin_id: "ID-Code (Admin Only)",
        ai_context_analysis_confirm: "Run AI Context Analysis?\n(Existing data will be overwritten)",
        ai_analyzing_background: "Requesting AI Analysis... (Background)",
        ai_no_items_found: "No items analyzed...",
        upload_fail: "Upload Failed: ",
        creating_episode: "Creating New Episode...",
        episode_not_found: "Episode not found.",
        uploading_images_toast: "Uploading images...",
        approval_request_sent: "Approval request sent. (Pending Admin Review)",
        publish_success: "Successfully Published!",
        temp_saved_toast: "Temporarily Saved.",
        deleted_toast: "Deleted.",
        access_denied: "Access Denied",




        save_success: "Saved",
        publish_confirm: "Confirm Publish",


        input_title_placeholder: "Enter title",
        ai_analyze_local: "AI Analyze (Local)",

        back_to_list: "Back to List",
        edit: "Edit",
        delete: "Delete",
        ai_analyze_admin: "AI Analyze (Admin)",
        ai_confirm: "AI Confirm",



        publish_complete: "Publish Complete",
        save_complete: "Save Complete",
        free_limit: "Free Episode Limit",
        free_limit_placeholder: "Leave empty for global/series default",
        free_limit_desc: "* Overrides global settings if set.",
        admin_edit_anytime: "* Admin can edit this anytime.",
        cancel: "Abbrechen",
        create: "Erstellen",
        episode_list: "Episodenliste",
        status_published: "Veröffentlicht",
        status_draft: "Entwurf",
        edit_detail_guide: "Edit details in editor",
        refreshing_list: "Refreshing list...",
        load_fail: "Load failed: ",
        no_cover: "No Cover",
        badge_ai: "AI Generated",
        no_episodes: "No episodes.",
        open_editor_fullscreen: "Editor öffnen (Vollbild)",
        admin_zone: "Admin-Zone",
        admin_zone_desc: "Diese Informationen sind beschränkt.",
        download_csv: "CSV herunterladen (ISBN)",
        adult_confirm_title: "18+ Warnung",
        adult_confirm_body: "Als 'Erwachsene (19+)' festlegen?\\n\\n- Blockiert den Zugriff für Minderjährige.\\n- Identitätsprüfung kann erforderlich sein.",
        davinci_lock_title: "🚧 In Entwicklung",
        davinci_lock_desc: "Da Vinci Modus (Cine-Novel) ist im Beta-Test.<br>Zugriff nur für <strong>Administratoren</strong> wegen Instabilität.<br><div class='mt-3 text-rose-400 font-bold'>Coming Soon.</div>",
        preview_preparing: "Vorschau wird vorbereitet...",

        select_chapter: "Kapitel wählen",
        episode_placeholder: "z.B. Ep. 1 Der Anfang",
        bgm_placeholder: "Suno KI URL...",
        content_placeholder: "Beginnen Sie Ihre Geschichte...",
        note_placeholder: "Ein Wort an die Leser...",

        ai_analysis_fail: "KI-Analyse-Fehler: ",
        save_fail: "Speicherfehler: ",
        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "* Selecting 19+ will block minors and require identity verification.",
        age_lock_warning: "Warning: Once saved, authors cannot change this setting. Contact admin for changes.",
        is_ai_desc: "Must be checked if AI-generated images or text are used.",
        publish_settings: "Publish Settings",
    },

    rating_guide: {
        title: "Inhaltsbewertungsleitfaden",
        all_title: "Jedes Alter",
        all_desc: "Inhalte für alle Altersgruppen geeignet.<br>Keine oder sehr milde Gewalt, sexuelle Inhalte oder unangemessene Sprache.",
        title_12: "12+ (Teens)",
        desc_12: "Kann milde Gewalt, schlechte Sprache oder Horror enthalten.<br>Elterliche Anleitung für Kinder unter 12 Jahren empfohlen.",
        title_15: "15+ (Junge Erwachsene)",
        desc_15: "Kann mäßige Gewalt, starke Sprache oder reife Themen enthalten.<br>Kann kriminelles Verhalten oder soziale Tabus darstellen.",
        title_19: "19+ (Nur Erwachsene)",
        desc_19: "Enthält explizite sexuelle Inhalte, extreme Gewalt oder beleidigende Sprache.<br><strong class='text-red-500'>Rechtlich auf Erwachsene ab 19 Jahren beschränkt. Identitätsprüfung erforderlich.</strong>",
        disclaimer: "* Die Bewertung liegt in der Verantwortung des Autors. Falsche Bewertungen können zu erzwungenen Änderungen oder Strafen führen.",
        confirm: "Verstanden"
    },
    davinci: {
        episode_settings: "Episodeneinstellungen",
        title: "Titel",
        thumbnail: "Vorschaubild",
        bgm: "BGM",
        add_block: "Block hinzufügen",
        text_block: "Text",
        image_block: "Bild",
        upload_image: "Foto hochladen",
        upload_thumb: "Vorschaubild hochladen",
        upload_success: "Hochgeladen",
        bgm_placeholder: "Suno URL oder MP3-Link",
        tip: "Tipp:",
        drag_tip: "Blöcke ziehen zum Sortieren.",
        save_draft: "Entwurf speichern",
        publish: "Veröffentlichen",
        saving: "Speichert...",
        published: "Veröffentlicht! Für Leser sichtbar.",
        publish_confirm: "Jetzt veröffentlichen? Leser werden dies sehen.",
        preview_preparing: "Vorschau wird vorbereitet...",
        thumbnail_uploading: "Vorschaubild wird hochgeladen...",
        thumbnail_applied: "Vorschaubild angewendet",
        guide: {
            title: "Tasten-Anleitung",
            save: "Speichern",
            save_desc: "Änderungen speichern.",
            draft: "Entwurf",
            draft_desc: "Auf privat setzen.",
            publish: "Veröffentlichen",
            publish_desc: "Öffentlich machen. (Für Leser sichtbar)",
            auto_save: "Auto-Save",
            auto_save_on: "AN (3s)",
            auto_save_desc: "Speichert automatisch alle 3 Sekunden."
        }
    },
    intro: {
        slogan: "Menschliche Kreativität, KI-Skalierbarkeit",
        hero_title: "Der Babelfisch",
        hero_subtitle: "für Cine-Novels.",
        status_active: "Übersetzungs-Engine Aktiv",
        status_cine: "Cine-Novel Format",
        desc_1: "Lesen Sie koreanische IPs sofort in <span class='text-white font-bold mx-1'>10 Sprachen</span> mit unserer zerstörungsfreien KI.",
        desc_2: "Erleben Sie das <span class='text-white font-bold mx-1'>weltweit erste Hybridformat</span>, in dem Bilder und Romane verschmelzen.",
        cta_start: "Kostenlos lesen",
        compare_title: "Zerstörerisch vs Zerstörungsfrei",
        compare_desc: "Wir berühren niemals die Originalpixel. Sehen Sie den Unterschied.",
        compare_old: "Alte Methode (Weiße Box)",
        compare_new: "Ssulwha Engine (R.A.P.S)",
        white_box_removed: "Entfernte weiße Boxen",
        format_title: "Jenseits statischer Bilder",
        format_desc: "Webtoon-Visuals. Romantiefe. Filmische Immersion.",
        geo_title: "KI-gesteuertes Wachstum",
        geo_desc: "Wir machen kein Marketing. Unsere KI erledigt das.",
        term_log_1: "Inhalt wird analysiert...",
        term_log_2: "Schlüsselwörter extrahieren...",
        term_log_3: "JSON-LD Metadaten injizieren...",
        term_log_4: "Organisches Wachstum +300%",

        // Missing Keys Added
        slider_old_title: "Alte Methode",
        slider_old_desc: "BLOCKIERT DIE KUNST",
        slider_new_title: "Ssulwha Engine (R.A.P.S)",
        slider_new_desc_1: "\"So sollte es sein.\"",
        slider_new_desc_2: "Der Text schwebt natürlich und bewahrt das Kunstwerk.",

        phone_analyzing: "Analysieren...",
        phone_detected: "Erkannt",
        phone_text_1: "Ist das mein Schicksal?",
        phone_cine_ep: "CINE-NOVEL EP.01",
        phone_cine_text_1: "Die Neonlichter flackerten und spiegelten sich in seinen kalten Augen.",
        phone_cine_text_2: "\"Es ist nicht nur eine Übersetzung\", murmelte er. \"Es ist eine neue Realität.\"",

        footer_copyright: "Angetrieben von R.A.P.S Engine."
    }
};
